export const MIN_LINE_COUNT_FOR_BACKGROUND = 100;

const countFileLines = async (file: File): Promise<number> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (event) => {
      try {
        const text = event.target?.result as string;
        if (!text) {
          resolve(0);
          return;
        }

        // Handle empty string case explicitly
        if (text === "") {
          resolve(0);
          return;
        }

        const lineCount = text.split("\n").length;
        resolve(lineCount);
      } catch (error) {
        reject(error);
      }
    };

    reader.onerror = () => {
      reject(new Error("Failed to read file"));
    };

    reader.readAsText(file);
  });
};

export const shouldRunCsvInBackground = async (
  file: File,
): Promise<boolean> => {
  try {
    const lineCount = await countFileLines(file);
    return lineCount > MIN_LINE_COUNT_FOR_BACKGROUND;
  } catch (error) {
    console.warn(
      "Failed to count file lines, defaulting to foreground:",
      error,
    );
    return false;
  }
};

export { countFileLines };
